











import { Component } from "vue-property-decorator";

import AppVue from "@/AppVue.vue";
import { AccountService } from "@/core/services";

@Component
export default class SsoView extends AppVue {
  created() {
    if (!this.$auth.isAuthenticated()) {
      AccountService.authenticate(this.$route.params.token);
      this.notify("Success", "You are now logged in.", "success");
    }

    this.$router.push(this.isAdmin ? "/admin/dashboard" : "/questionnaire");
  }
}
